import { render, staticRenderFns } from "./ModalCABase.vue?vue&type=template&id=70fadd45&scoped=true&"
import script from "./ModalCABase.vue?vue&type=script&lang=js&"
export * from "./ModalCABase.vue?vue&type=script&lang=js&"
import style0 from "./ModalCABase.vue?vue&type=style&index=0&id=70fadd45&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fadd45",
  null
  
)

export default component.exports